import { connect } from 'react-redux';
import _values from 'lodash/values';
import GraphicsArea from '../components/Graphics/GraphicsArea';
import { moveChart } from '../actions/engineering';
import * as pages from '../constants/pages';

const shouldShowUnity = (mainPage, researchPage, researchPageCategory) => {
  if (
    mainPage === pages.PAGE_ENGINEERING ||
    mainPage === pages.PAGE_SIMULATION
  ) {
    return true;
  }

  return !!(
    mainPage === pages.PAGE_RESEARCH &&
    researchPage &&
    researchPageCategory === 'interactive'
  );
};

const mapStateToProps = (state, ownProps) => {
  const mainPage = state.app.page;
  const researchPage = state.research.selectedPage;
  const researchPageCategory = state.research.exercises.find(
    (ex) => ex.code === researchPage
  )?.category;
  const openWorkAreas =
    _values(state.engineering.workAreas).filter((wa) => wa.open === true)
      .length > 0;
  const openHelp = state.research.isHelpOpen;
  let numPanels = 2; // engineering toolbar and unity
  if (openHelp) {
    numPanels++;
  }
  if (openWorkAreas) {
    numPanels++;
  }

  return {
    visible: shouldShowUnity(mainPage, researchPage, researchPageCategory),
    numPanels,
    ...ownProps,
  };
};

const mapDispatchToProps = {
  moveChart,
};

const Graphics = connect(mapStateToProps, mapDispatchToProps)(GraphicsArea);

export default Graphics;
